import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import ComprobanteStatusInfo from './info/components/ComprobanteStatusInfo';
import ComprobanteGeneralInfo from './info/components/ComprobanteGeneralInfo';
import ComprobanteConceptoInfo from './info/components/ComprobanteConceptoInfo';

class ComprobantesInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { uuid } = props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: !!data.uuid ? { ...data } : { uuid },
    };
  }

  componentDidMount() {
    const { uuid } = this.state.data;
    const params = {
      include: 'conceptos,sat_url',
    };

    this.props.infoActions.info(uuid, params);
  }

  renderConceptos = (item) => (
    <ComprobanteConceptoInfo
      key={item.id}
      data={item}
      className="mb-2"
    />
  );

  render() {
    const { data = {}, busy } = this.props.info;

    if (busy) {
      return <Loading />;
    }

    return (
      <>
        <div className="page-header">
          <Link to="/app/comprobantes">&#8592; Facturas</Link>
        </div>

        <h5>{data.uuid}</h5>

        {!!data.uuid && (
          <div>
            <ComprobanteStatusInfo data={data} />

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <ComprobanteGeneralInfo data={data} />

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Conceptos</strong>
            </div>

            {!!data.conceptos && data.conceptos.data.map(this.renderConceptos)}
          </div>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return { info: store.app.comprobantes.info };
};

const mapActions = (actions) => {
  return { infoActions: actions.app.comprobantes.info };
};

export default connect(useStore, mapState, mapActions)(ComprobantesInfo);
